__webpack_require__.p = "http://clinical-hxorganization-test.hxxlpg.com/";